export default "/assets/recipes-purple.svg";